"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClauseReferenceMarkdownDirectiveDefinition = void 0;
exports.parseClauseReferenceLabel = parseClauseReferenceLabel;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.ClauseReferenceMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['label'],
    contentAttributeName: 'label',
    directive: 'clause',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
});
const CLAUSE_REFERENCE_PATTERN = /^([a-z][a-z0-9_]*)\s*#\s*(\d+)(?:\s+v(\d+))?$/i;
function parseClauseReferenceLabel(label) {
    const match = CLAUSE_REFERENCE_PATTERN.exec(label.trim());
    if (match === null) {
        return undefined;
    }
    const [, propertyKey, clauseNumber, version] = match;
    if (propertyKey === undefined || clauseNumber === undefined) {
        return undefined;
    }
    return {
        propertyKey: propertyKey.toLowerCase(),
        clauseNumber: Number(clauseNumber),
        version: version === undefined ? null : Number(version),
    };
}
//# sourceMappingURL=ClauseReference.js.map